var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-whatwedo"},[_c('div',{staticClass:"about-whatwedo-title"},[_vm._v(_vm._s(_vm.lenguageSelected.title))]),_c('p',[_vm._v(_vm._s(_vm.lenguageSelected.content1))]),_c('p',[_vm._v(_vm._s(_vm.lenguageSelected.content2))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddffde6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/PmWhatWeDo.vue
// module id = 162
// module chunks = 0